import React from 'react';

const FooterCompany = () => (
  <div className="text-center my-4">
    <small className="text-light">&copy; 2019 Flightspeed Tech Pty Ltd. All Rights Reserved</small>
  </div>
);

export default FooterCompany;
